import { Box, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CrusadeItem from '../../components/fragments/CrusadeItem';
import ExternalScreen from '../../components/fragments/ExternalScreen';
import ListEmpty from '../../components/fragments/ListEmpty';
import { rtGetListData } from '../../store/slices/listSlice';
import { generateRandomColor } from '../../utils/helpers';
import { GuestAppBar } from './GuestFeedScreen';

const filteredList = (list = [], q = '') =>
    list.filter((post) =>
        JSON.stringify(post)?.toLowerCase().includes(q?.toLowerCase())
    );

export default function CrusadeScreen() {
    const [search, setSearch] = useState('');

    const dispatch = useDispatch();
    const state = useSelector((st) => st);

    const { user } = state.auth;
    const { liveCrusades, scheduledCrusades, busy } = state.list2;

    useEffect(() => {
        dispatch(rtGetListData('crusades/live', 'liveCrusades', true));
        dispatch(rtGetListData('crusades', 'scheduledCrusades', true));
    }, [dispatch, user]);

    return (
        <ExternalScreen
            tab
            authPass
            disableAppBar
            title="Crusades"
            loading={busy['liveCrusades'] || busy['scheduledCrusades']}
        >
            <GuestAppBar tab onSearch={(text) => setSearch(text)} />
            {<Box sx={{ width: '100%', height: 72 }} />}
            <Grid sx={{ mx: 0.5 }} item xs={12}>
                <Typography variant="h6">Live Crusade</Typography>
                <Typography color="text.secondary">
                    Crusades going on right now
                </Typography>
            </Grid>
            {filteredList(liveCrusades, search)?.map((crusade) => (
                <CrusadeItem
                    key={crusade?.id}
                    crusade={crusade}
                    theme={() => generateRandomColor()}
                />
            ))}
            {filteredList(liveCrusades, search)?.length < 1 && <ListEmpty />}
            <Grid sx={{ mt: 2, mx: 0.5 }} item xs={12}>
                <Typography variant="h6">Coming Soon</Typography>
                <Typography color="text.secondary">
                    Set reminder to tune in
                </Typography>
            </Grid>
            {filteredList(scheduledCrusades, search)?.map((crusade) => (
                <CrusadeItem
                    key={crusade?.id}
                    crusade={crusade}
                    theme={() => generateRandomColor()}
                />
            ))}
            {filteredList(scheduledCrusades, search)?.length < 1 && (
                <ListEmpty />
            )}
        </ExternalScreen>
    );
}
